export const ASSISTENTE_RECOMENDACAO_OBTER = "ASSISTENTE_RECOMENDACAO_OBTER";
export const ASSISTENTE_RECOMENDACAO_SALVAR = "ASSISTENTE_RECOMENDACAO_SALVAR";
export const ASSISTENTE_RECOMENDACAO_LISTAR = "ASSISTENTE_RECOMENDACAO_LISTAR";
